if (!process.browser && !__webpack_share_scopes__.default) {
        Object.assign(__webpack_share_scopes__, {
            default: {
                
    "react": {
        [React.version]: {
            loaded: true,
            get: () => Promise.resolve(() => require("react")),
        },
    },
    
    "react-dom": {
        [React.version]: {
            loaded: true,
            get: () => Promise.resolve(() => require("react-dom")),
        },
    },
    
    "next": {
        "14.2.25": {
            loaded: true,
            get: () => Promise.resolve(() => require("next")),
        },
    },
    
    "next/head": {
        "14.2.25": {
            loaded: true,
            get: () => Promise.resolve(() => require("next/head")),
        },
    },
    
    "next/dynamic": {
        "14.2.25": {
            loaded: true,
            get: () => Promise.resolve(() => require("next/dynamic")),
        },
    },
    
    "@zillow/dynamic-import-remote": {
        "1.2.4": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/dynamic-import-remote")),
        },
    },
    
    "@zillow/frontier/dynamic": {
        "0.23.1-feat-trackloadedmanifests-58acee96.7+58acee9": {
            loaded: true,
            get: () => Promise.resolve(() => require("@zillow/frontier/dynamic")),
        },
    },
    
    "styled-components": {
        "5.3.11": {
            loaded: true,
            get: () => Promise.resolve(() => require("styled-components")),
        },
    },
    
            },
        });
    }import { datadogRum } from '@datadog/browser-rum';
import { BlockEnvironmentProvider } from '@zillow/cms-blocks';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import unusedDefaultDynamic, {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    dynamic as frontierDynamic,
    DynamicImportRemoteLoadableContext as FrontierLoadableContext,
} from '@zillow/frontier/dynamic';
import { appendZhlParams } from '@zillow/mortgage-urls';
import { AppWrapper } from '@zillow/page-frame-next-components';
import { page, setdim } from '@zillow/universal-analytics';
import {
    PagePropsProvider,
    ThemeCmsConstellation,
    ThemeSkunkWorksCmsConstellation,
    getCmsInfoForPage,
} from '@zillow/zrs-cms';
import { merge } from 'lodash';
import App from 'next/app';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as _unusedNextDynamic from 'next/dynamic';
import Head from 'next/head';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import 'regenerator-runtime/runtime';
import { ThemeProvider } from 'styled-components';

import { clientProfilerConfig } from '../../server/config';
import VisualRefreshFonts from '../components/VisualRefreshFonts/VisualRefreshFonts';
import { trackExposureEvent } from '../util/optimizely';
let dynamicRemotes;

const DynamicRemotesList = () => {
    return (
        <script
            id="__WEB_PLATFORM_DYNAMIC_MODULES"
            dangerouslySetInnerHTML={{
                __html: `${JSON.stringify(dynamicRemotes)}`,
            }}
        />
    );
};

function isMobile() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ];

    return (
        typeof window !== 'undefined' &&
        toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem))
    );
}

if (typeof window !== 'undefined') {
    datadogRum.init({
        applicationId: '670a99d8-3d41-4858-ae1f-cb66797af887',
        clientToken: 'pubb1845c6bcbfd371c2a207a83befcffc0',
        site: 'datadoghq.com',
        service: 'cms-constellation',
        env: process.env.NEXT_PUBLIC_ENV,
        version: process.env.NEXT_PUBLIC_SERVICE_VERSION,
        sessionSampleRate: parseInt(
            process.env.NEXT_PUBLIC_DATADOG_RUM_SAMPLE_RATE || '0'
        ),
        startSessionReplayRecordingManually: true,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
    });
}

const MyApp = ({ Component, pageProps }) => {
    dynamicRemotes = [];

    useEffect(() => {
        // For how-much-is-my-home-worth analytics
        const params = new URLSearchParams(window.location.search);
        if (params.has('zpid')) {
            setdim({ dimension2: params.get('zpid') });
        }
        // https://gitlab.zgtools.net/zillow/npm/universal-analytics/-/blob/master/README-NEWLANE.md#pagepath-properties-options
        // https://dataportal.zillowgroup.net/event-registry/2284
        page(
            window.location.pathname,
            {},
            {
                newLaneEvent: {
                    envelope: {
                        event_type_id: '2284',
                        event_type_version_id: '1',
                        event_template_id: '126',
                        event_template_version_id: '1',
                    },
                    clickstream_trigger: {
                        trigger_type_nm: 'view',
                        trigger_location_nm: 'cms',
                        trigger_source_nm: 'cms',
                        trigger_object_nm: 'no_trigger_object',
                    },
                    semantic: {
                        semantic_event_nm: 'view_content',
                    },
                    cms_info: getCmsInfoForPage(pageProps),
                },
            }
        );

        window.addEventListener('load', () => {
            appendZhlParams(document);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Disable Chrome's behavior where if the current user has already visited
    // the page and has scrolled to a given point, Chrome will restore that
    // scroll position and ignore the deep link.
    useEffect(() => {
        if ('scrollRestoration' in window.history && window.location.hash) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    // Track Optimizely exposure events with Clickstream.
    useEffect(() => {
        trackExposureEvent();
    }, []);

    return (
        <>
            <FrontierLoadableContext.Provider
                value={(dynamicRemote) => dynamicRemotes.push(dynamicRemote)}
            >
                <AppWrapper
                    clientProfilerConfig={merge(clientProfilerConfig, {
                        staticDimensions: {
                            platform: isMobile() ? 'mobile' : 'desktop',
                        },
                    })}
                >
                    <ThemeProvider
                        theme={
                            pageProps.useVisualRefreshTheme
                                ? ThemeSkunkWorksCmsConstellation
                                : ThemeCmsConstellation
                        }
                    >
                        <PagePropsProvider pageProps={pageProps}>
                            <BlockEnvironmentProvider
                                environment={process.env.NEXT_PUBLIC_ENV}
                            >
                                {pageProps.useVisualRefreshTheme && (
                                    <VisualRefreshFonts />
                                )}
                                <Component {...pageProps} />
                            </BlockEnvironmentProvider>
                        </PagePropsProvider>
                    </ThemeProvider>
                </AppWrapper>
            </FrontierLoadableContext.Provider>
            <Head>
                <DynamicRemotesList />
            </Head>
        </>
    );
};

MyApp.getInitialProps = async (appContext) => {
    const appProps = await App.getInitialProps(appContext);
    return { ...appProps };
};

MyApp.propTypes = {
    Component: PropTypes.elementType.isRequired,
    pageProps: PropTypes.object.isRequired,
};

export default MyApp;
